// Filters
const archiveFilter = document.querySelector('.archive-filter');

function fetchFromUrlToSelector(url, selector) {
    const container = document.querySelector(selector);
    container.classList.add('loading');
    history.pushState({}, '', url);

    fetch(url)
        .then(response => response.text())
        .then(html => {
            const temp = document.createElement('div');
            temp.innerHTML = html;
            const newContent = temp.querySelector(selector);

            if (newContent) {
                container.innerHTML = newContent.innerHTML;
            }

            container.classList.remove('loading');
        });
}

function executeFilter() {
    const queryString = new URLSearchParams(new FormData(archiveFilter)).toString();
    fetchFromUrlToSelector(archiveFilter.action + '?' + queryString, '.archive-content');
}

if (archiveFilter) {

    const submitButton = archiveFilter.querySelector('button[type="submit"]');

    archiveFilter.addEventListener('submit', e => {
        e.preventDefault();
        executeFilter();
    });

    // archiveFilter.addEventListener('change', e => {
    //     if ((e.target.type === 'checkbox' || e.target.type === 'radio') && e.target.value !== 'custom') {
    //         executeFilter();
    //     }
    // });

    submitButton.addEventListener('click', e => {
        e.preventDefault();
        executeFilter();
    });
}

// check if input with name ec_period is clicked and value is custom 
const inputPeriod = document.querySelectorAll('input[name="ec_period"]');

if (inputPeriod) {

    const customDate = document.querySelector('.custom-date');

    inputPeriod.forEach(input => {
        input.addEventListener('click', e => {
            if (e.target.value === 'custom') {
                customDate.classList.remove('hidden');
            } else {
                customDate.classList.add('hidden');
            }
        });
    });
}